import { useProgram } from '@cibo/programs'
import { SaveIndicatorProvider } from '@cibo/ui/src/components/SaveIndicator/SaveIndicatorProvider'
import { Container, Stack, Typography } from '@mui/material'
import { generatePath, useParams } from 'react-router-dom'
import { SaveIndicator } from '../../consts/Theme'
import { ProgramEngagementProvider } from '../../features/ProgramEngagement'
import { PROGRAM_ROUTES } from '../../navigation/types/routes'
import { ProgramLayout } from '../Growers/ProgramLayout'

export const EngagementsRoot = () => {
  const { programId } = useParams<{ programId: string; engagementId: string }>()
  const program = useProgram({ programId })

  if (!programId) return null

  return (
    <SaveIndicatorProvider>
      <ProgramEngagementProvider
        basePath={generatePath(PROGRAM_ROUTES.ENGAGEMENTS, {
          programId,
        })}
        userId={Number.NaN}
        programId={programId ?? ''}
      >
        <Container>
          <Stack justifyContent="space-between" direction="row" pt={2.5} px={3}>
            <Typography color="text.secondary">
              {program.data?.content?.fields.title ?? ''}
            </Typography>
            <SaveIndicator />
          </Stack>

          <Stack flex={1}>
            <Stack justifyContent={'flex-start'} p={3}>
              <ProgramLayout />
            </Stack>
          </Stack>
        </Container>
      </ProgramEngagementProvider>
    </SaveIndicatorProvider>
  )
}
